import React from 'react'

// Utils
import { setStringifiedItem, getParsedItem } from 'utils/localStorage'

// Constants
import { routes } from 'constants/routes'
import localStorageKeys from 'constants/localStorageKeys'

//Components
import Modal from 'components/Modal'

// Styles
import {
  Title,
  SubTitle,
  Columns,
  Column,
  Paragraph,
  Note,
  StyledModal,
  StyledButton,
  StyledLinkButton,
} from './WorkspaceWelcomeModal.styles'

//  Types
import { ModalInjectedProps } from 'containers/ModalManager'

interface WorkspaceWelcomeModalProps extends ModalInjectedProps {
  workspaceId: string
}

const WorkspaceWelcomeModal: React.FC<WorkspaceWelcomeModalProps> = ({
  hideModal,
  workspaceId,
}) => {
  const handleHideModal = () => {
    // Grab all dismissed workspace ID's from local storage
    const previouslyDismissedIDs =
      getParsedItem(localStorageKeys.dismissedWelcomeModal) ?? []

    const currentDismissedIDs = [...previouslyDismissedIDs, workspaceId]

    // Set the current workspace ID to the list of dismissed modals
    setStringifiedItem(
      localStorageKeys.dismissedWelcomeModal,
      currentDismissedIDs
    )
    hideModal()
  }

  return (
    <StyledModal onCancel={handleHideModal}>
      <Modal.Body>
        <Title>More Sketch for Less</Title>
        <Columns>
          <Column>
            <SubTitle>Start with a Free Trial</SubTitle>
            <Paragraph>
              Begin with a <strong>fully unlocked 30-day trial</strong> that
              includes the world-class Mac app and a Workspace for
              collaborating.
            </Paragraph>
            <Paragraph>
              To keep using Sketch, subscribe any time before your trial ends.
            </Paragraph>
            <StyledButton
              variant="secondary-untinted"
              onClick={handleHideModal}
              small>
              Go to Workspace
            </StyledButton>
          </Column>
          <Column withBackground>
            <SubTitle>Then just $9 per Month</SubTitle>
            <Paragraph>
              Access to the Mac app, real-time collaboration, a Workspace for
              your team, automatic updates and document versioning.
            </Paragraph>
            <Paragraph>
              <strong>Got an active license?</strong> Trade it in to get credit
              on your subscription.
            </Paragraph>
            <StyledLinkButton
              variant="primary-untinted"
              to={routes.WORKSPACE_SUBSCRIBE.create({
                workspaceId,
              })}
              onClick={handleHideModal}
              small>
              Set Up Subscription
            </StyledLinkButton>
          </Column>
        </Columns>
        <Note>
          After the trial ends you will no longer have access to Workspaces or
          the Mac app. Expired Workspaces become inactive after 90 days.
        </Note>
      </Modal.Body>
    </StyledModal>
  )
}

export default WorkspaceWelcomeModal
